import ModalPopup from "../../../components/newcomponents/ModalPopup";
import close from "../images/epic-close.svg";
import { useState } from "react";
import CreateTemplateCont from "../container/CreateTemplateCont";
import ViewNotesTemplates from "./viewTemplatesListing";
import TemplateSummaryCont from "../container/TemplateSummaryCont";
const SelectTemplatesComp = (props) => {
   const [showTemplate, setShowTemplate] = useState(false);
   const { setShowTemplatePopup, onModalTapped, getNotesTemplate = () => {} } = props;
   const [showTempSummary, setShowTempSummary] = useState(false);

   const handleClose = () => {
      onModalTapped();
      getNotesTemplate(false);
   };
   return (
      <>
         {!showTempSummary ? (
            <ModalPopup>
               <div className="d-relative epic-select-temp-modalPopup box-shadow">
                  {!showTemplate ? (
                     <>
                        <div className="select-temp-text mb-4 pt-5 mt-2">Add Templates</div>
                        <img onClick={handleClose} src={close} alt="close" className="close-image cursor-pointer" />
                        <ViewNotesTemplates setShowTempSummary={setShowTempSummary} />
                        <div className="flex-center epic-temp-create-padding ">
                           <button onClick={handleClose} className="epic-temp-button-container flex-center">
                              <div className="note-category-text">Done</div>
                           </button>
                        </div>
                     </>
                  ) : (
                     <CreateTemplateCont
                        setShowTemplatePopup={setShowTemplatePopup}
                        setShowTemplate={setShowTemplate}
                        getNotesTemplate={getNotesTemplate}
                     />
                  )}
               </div>
            </ModalPopup>
         ) : (
            <TemplateSummaryCont
               templateId={showTempSummary}
               setShowTempSummary={setShowTempSummary}
               onModalTapped={onModalTapped}
               getNotesTemplate={getNotesTemplate}
            />
         )}
      </>
   );
};

export default SelectTemplatesComp;
